import { render, staticRenderFns } from "./evolve.vue?vue&type=template&id=487f82c8&scoped=true"
import script from "./evolve.vue?vue&type=script&lang=js"
export * from "./evolve.vue?vue&type=script&lang=js"
import style0 from "./evolve.vue?vue&type=style&index=0&id=487f82c8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487f82c8",
  null
  
)

export default component.exports